import { setVizMode, VIZ_MODES, vizState } from "./render/viz-mode";
import { makePanelHeader } from "./util/panel";

export class VizPanel {
  private root: HTMLDivElement;
  private buttons = new Map<string, HTMLButtonElement>();
  private visible = false;
  private onChange?: () => void;

  constructor() {
    this.root = document.createElement("div");
    this.root.id = "viz-panel";
    this.root.className = "panel viz-panel";
    this.root.style.display = "none";

    this.root.appendChild(makePanelHeader("VISUALIZER", () => this.hide()));

    const body = document.createElement("div");
    body.className = "viz-body";
    for (const mode of VIZ_MODES) {
      const btn = document.createElement("button");
      btn.className = "viz-mode-btn";
      btn.textContent = mode.label;
      btn.addEventListener("click", () => {
        setVizMode(mode.key);
        this.syncActive();
        this.onChange?.();
      });
      body.appendChild(btn);
      this.buttons.set(mode.key, btn);
    }
    this.root.appendChild(body);
    this.syncActive();

    document.body.appendChild(this.root);
  }

  setOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  private syncActive(): void {
    for (const [key, btn] of this.buttons) {
      btn.classList.toggle("active", vizState.mode.key === key);
    }
  }

  show(): void {
    this.visible = true;
    this.root.style.display = "flex";
    this.syncActive();
  }

  hide(): void {
    this.visible = false;
    this.root.style.display = "none";
  }

  toggle(): void { this.visible ? this.hide() : this.show(); }
  isVisible(): boolean { return this.visible; }
}
